/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { useMemoSelector } from '@spa/redux/hooks'
import { isEqual } from 'lodash-es'
import type { FC, PropsWithChildren } from 'react'
import React, { memo } from 'react'
import { useDispatch } from 'react-redux'

import type { SelectedTarget } from '../../redux/reducers'
import { setSelectedTarget } from '../../redux/reducers'
import {
  getGridSelection,
  isSameSelectedContract,
  isSameSelectedDay
} from '../../redux/selectors'

import { BaseTarget } from './BaseTarget'

type Props = PropsWithChildren<{
  targetType: SelectedTarget
  className?: string
}>

export const CellTarget: FC<Props> = memo(
  ({ targetType, className, children }) => {
    const dispatch = useDispatch()
    const { selected, copied, focused } = useMemoSelector(getGridSelection)

    const isCopied = isEqual(copied?.data, targetType.data)
    const isSameContract = isSameSelectedContract({ selected, targetType })
    const isSameDay = isSameSelectedDay({ selected, targetType })
    const isSameWeeklyschedule =
      targetType?.data?.weeklyscheduleId === selected?.data?.weeklyscheduleId

    const isSelected =
      isSameContract && isSameDay && targetType?.target === selected?.target

    const isSameDayColumn =
      selected?.target === 'day' && isSameDay && isSameWeeklyschedule
    const isSameContractRow =
      selected?.target === 'row' && isSameContract && isSameWeeklyschedule
    const isGroupSelected = isSameDayColumn || isSameContractRow

    return (
      <BaseTarget
        border={isSameDay ? 'x' : 'y'}
        copied={isCopied}
        focused={focused}
        selected={isSelected}
        groupSelected={isGroupSelected}
        className={className}
        onClick={() => {
          dispatch(setSelectedTarget(targetType))
        }}
      >
        {children}
      </BaseTarget>
    )
  }
)
